import { default as Tree } from '@/components/tree-structure/TreeStructure';
import { ScenarioSidebar } from '@/styles/scenario';
import axios from '@/utils/axios';
import { convertDemandToHierarchy } from '@/utils/utils';
import React from 'react';
import { useQuery } from 'react-query';

interface DemandTreeProps {
	scenarioId: TValue | undefined;
	selectedItem: TDemandTreeSelectedItem | undefined;
	setSelectedItem: React.Dispatch<
		React.SetStateAction<TDemandTreeSelectedItem | undefined>
	>;
}

const DemandTree: React.FC<DemandTreeProps> = ({
	scenarioId,
	selectedItem,
	setSelectedItem,
}) => {
	const { data: tree } = useQuery(
		[`demand_tree`, scenarioId],
		() =>
			axios.get<TDemandTree>(`/demand_tree`, {
				params: {
					scenario_id: scenarioId,
				},
			}),
		{
			enabled: !!scenarioId,
		}
	);
	return (
		<ScenarioSidebar>
			<Tree
				selectedEntryId={selectedItem?.value as string}
				onSelect={(entry, depth) => {
					const isSalesRegionSelected = depth === 1;
					const selected = tree?.data.find((item) => {
						const itemId = isSalesRegionSelected
							? item.sales_region
							: `${item.sales_region}-${item.family_code}`;
						return itemId === entry.id;
					});
					setSelectedItem({
						item: selected!,
						value: entry.id,
						depth,
					});
				}}
				treeData={convertDemandToHierarchy(tree?.data ?? [])}
			/>
		</ScenarioSidebar>
	);
};

export default DemandTree;
